import { NOT_APPLICABLE } from '@config/constants/common';
import { Box } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import classes from './DownloadTag.module.css';

export const DownloadTag = ({
	label,
	url,
}: {
	label?: string;
	url: string;
}) => {
	return (
		<Box
			className={classes.container}
			onClick={() => {
				window.open(url, '_blank');
			}}
		>
			{label || NOT_APPLICABLE}
			<IconDownload
				data-testid="download-icon"
				size={'20px'}
			/>
		</Box>
	);
};
